import axios from 'axios'
import { format } from '../../../../services/format'

const geonames = 'http://api.geonames.org/'
const geonamesKey = 'raf'
const defaultLang = 'fr'

const schemaPlace = {
  name: 'geonames.0.name',
  coords: (data) => [data.geonames[0].lng, data.geonames[0].lat],
  distance: 'geonames.0.distance',
  region: 'geonames.0.adminName1',
  country: 'geonames.0.countryName',
  code: 'geonames.0.countryCode'
}

// from a point returns the place information from geoname
export const getPlace = (aLonLat, lang = defaultLang) => {
  const url = `${geonames}findNearbyPlaceNameJSON?lat=${aLonLat[1]}&lng=${aLonLat[0]}&lang=${lang}&username=${geonamesKey}`
  return new Promise((resolve, reject) => {
    axios.get(url)
      .then(res => resolve(format(schemaPlace, res.data)))
      .catch(err => reject(err))
  })
}
// getPlace([2.14095,48.9538]).then(res => console.log(JSON.stringify(res, null, 2)))
// getPlace([2.36,48.86]).then(res => console.log(JSON.stringify(res, null, 2)))

export const getPlaces = (aPoints, lang = defaultLang) => {
  const pointsPromises = aPoints.map(aLonLat => getPlace(aLonLat, lang))
  return new Promise((resolve, reject) => {
    Promise.all(pointsPromises)
      .then(values => resolve(values))
      .catch(err => reject(err))
  })
}
// getPlace([[2.14095,48.9538],[2.36,48.86]]).then(res => console.log(JSON.stringify(res, null, 2)))
